module.exports = __webpack_public_path__ + "img/241.898ecccb.jpg";